module.exports = __webpack_public_path__ + "static/media/Julfikar Steel Calender 2025.c13e54c7.pdf";